/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable max-classes-per-file */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { defaults as _defaults } from 'lodash';
class ExpRptUDF {
    PK;
    Name;
    Code;
    constructor(ExpRptUDF) {
        _defaults(this, ExpRptUDF);
    }
}
class EmpUDF extends ExpRptUDF {
    constructor(EmpUDF) {
        super(EmpUDF);
        _defaults(this, EmpUDF);
    }
}
class ExpRptUDFConfig {
    Label;
    Required;
    UseSearch;
    HasBlank;
    constructor(ExpRptUDFConfig) {
        _defaults(this, ExpRptUDFConfig);
    }
}
class EmpUDFConfig extends ExpRptUDFConfig {
    constructor(EmpUDFConfig) {
        super(EmpUDFConfig);
        _defaults(this, EmpUDFConfig);
    }
}
class TextUDFConfig {
    Label;
    Required;
    MinLength;
    MaxLength;
    Numeric;
    constructor(textUDFConfig) {
        _defaults(this, textUDFConfig);
    }
}
export { ExpRptUDF, EmpUDF, ExpRptUDFConfig, EmpUDFConfig, TextUDFConfig };
